import React from 'react'
import { Box, Grid, Typography, Link, useTheme } from '@mui/material'
import { ROUTES } from '../routes/routes'
import SEOHelmet from '../components/SEOHelmet'
import { DEFAULT_SEO, generateCanonicalUrl } from '../utils/seo'


const AboutUsPage: React.FC = () => {
  const theme = useTheme()

  return (
    <>
    <SEOHelmet
      {...DEFAULT_SEO.ABOUT_US}
      canonicalUrl={generateCanonicalUrl(ROUTES.ABOUT_US)}
    />
    <Box display="flex" flexDirection="column" pb={18}
      sx={{
        backgroundColor: theme.palette.custom.backgroundWhisperPurple,
        minHeight: 'calc(100vh - 151px)',
        paddingTop: { xs: 4, sm: 5, md: 10 }
      }}>
      <Grid container justifyContent="center">
        <Grid item xs={10} sm={10} md={8} lg={6} xl={4}>
          <Typography component="h1" sx={{
            typography: {
              xs: 'h5',
              sm: 'h4',
              md: 'h4',
              lg: 'h3'
            }
          }} gutterBottom>About us</Typography>

          <Typography variant="subtitle1" mb={2}>
            Welcome to TopConverters! The world is full of units, and we are here to help you convert between them. This is the most modern unit converter on the internet, with a focus on good user experience.
          </Typography>

          <Typography variant="body1" mb={2}>
            We have a wide range of converters available, and we are constantly adding more. If you have a specific converter or unit that you would like us to add, please let us know via the{' '}
            <Link underline="hover" href={ROUTES.CONTACT_US}>contact us page</Link>!
          </Typography>
        </Grid>
      </Grid>
    </Box>
    </>
  )
}


export default AboutUsPage
